export default {
  app: {
    golf: {
      title: 'Informacje o polu',
      hasEVChargingPoint: 'Punkt ładowania EV',
      hasCaddieService: 'Usługa caddiego',
      hasTrolley: 'Wózek',
      hasBuggy: 'Wózek golfowy',
      hasClubRental: 'Wypożyczalnia kijów',
      hasAcademy: 'Akademia',
      hasMarshal: 'Marszałek',
      hasPGACertification: 'Certyfikat PGA',
      hasTrainingArea: 'Strefa treningowa',
      hasRestaurant: 'Restauracja',
      hasHotel: 'Hotel',
      hasDogsOnCourse: 'Psy na polu',
      numberOfHoles: 'Liczba dołków',
    },
  },
};
